import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './ManageAccount.css';

const FUNDS_ADMIN_ACCOUNT_URL = 'https://funds.frasyndicate.com/admin/account';

function ManageAccount() {
  const { accounts, selectedAccountId } = useAuth();
  const selectedAccount = accounts?.find(a => a.id === selectedAccountId);

  return (
    <div className="manage-account">
      <div className="manage-account-card">
        <h2>Manage account</h2>
        
        {selectedAccount && (
          <div className="account-details">
            <p><strong>Account Name:</strong> {selectedAccount.name}</p>
            <p><strong>Account ID:</strong> <span className="account-id">{selectedAccount.id}</span></p>
          </div>
        )}

        <p className="manage-account-intro">
          Account management (create account, invite members, configure exchange keys) is done on the Fund Transfer Service.
        </p>
        <p className="manage-account-cta">
          To create or manage accounts and exchange credentials, go to the Fund Transfer Service.
        </p>
        <a
          href={FUNDS_ADMIN_ACCOUNT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="manage-account-link"
        >
          Open Fund Transfer Service – Account
        </a>
        <p className="manage-account-note">
          You will be taken to <strong>{FUNDS_ADMIN_ACCOUNT_URL}</strong>
        </p>
      </div>
    </div>
  );
}

export default ManageAccount;
